













































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import pmds from '@/mixins/axios/pmds'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    PmdHeader,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
           
            
         
            {
                tag:'nombre',
                data:'nombre_pmd',
                active:true
            },
           
             {
                tag:'ano',
                data:'ano_pmd',
                active:true
            },
             {
                tag:'finaliza_pmd',
                data:'finaliza_pmd',
                active:true
            },
              {
                tag:'active',
                data:'visible',
                active:true
            },
             {
                tag:'select_eje',
                data:'select',
                active:false
            },
               {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
           
            
        ],
    departamentos:false,

active:0,

        id:null as any,

      nombre_pmd:'' as any,
      ano_pmd:null as any,
     finaliza_pmd:null as any,
    
     
         
              pmd:[] as any,
              pmds:[] as any,
      
    }
  },
     mixins: [pmds],
     validations: {
    
           nombre_pmd: {
      required,
    },
      ano_pmd: {
      required,
    },
     finaliza_pmd: {
      required,
    },
      active: {
      required,
    },
       
     

   
  },
  methods:{
        onChangeVisible(event){

      },
        clearstate(){
this.$store.commit('SETPMD',null);
this.$store.commit('SETESTRATEGIA',null);
this.$store.commit('SETEJE',null);

 this.$router.push('/mun/general/pmd')
        },
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_PMDS(row).then(response => {

                    if (response != null) {

 this.pmds=this.pmds.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la página");

                    }
 this.$root.$emit('loading', false);
                });
      },
       select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
  this.active=null;
           
                 this.nombre_pmd=null;

            this.ano_pmd=null;
              this.finaliza_pmd=null;
            
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_pmd').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.nombre_pmd=row.nombre_pmd;
 this.active=row.active;
            this.ano_pmd=row.ano_pmd;
             this.finaliza_pmd=row.ano_pmd;
          
 $('#ac_modal_pmd').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_PMDS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.pmds.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar pmd, refresque la página");

                    } $("#ac_modal_pmd").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_PMDS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Pmd modificado correctamente.");
  this.pmds=this.pmds.filter(item => item.id !== dat.id);
 this.pmds.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear pmd, refresque la página");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
             
           nombre_pmd:this.nombre_pmd,
  
           active:this.active,

            ano_pmd:this.ano_pmd,
            finaliza_pmd:this.finaliza_pmd,
           
                 idmunicipio:this.$store.state.user.usuario.id_municipio
    
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_PMDS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.pmds=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

